export const FIELD_HOST = "field.workviewpro.com";
export const PREVIEW_FIELD_HOST = "field-preview.workviewpro.com";
export const FIELD_SIGN_IN_PATH = "/auth?app=field";

export function isFieldApp(hostname = window.location.hostname, search = "") {
  return hostname === FIELD_HOST || hostname === PREVIEW_FIELD_HOST || new URLSearchParams(search).get("app") === "field";
}
